// extracted by mini-css-extract-plugin
export default {"container":"qWXJM","innerContainer":"XFsyC","picture":"YmU6V","svg":"KPAmc","round":"mIRym","nameLetter":"MQ-RN","isMobile":"ttYNc"};